import { ActionDto, GetIssueResponseDto } from '@issuemanager/api-client';
import { MasterIssueRowModel } from './issue-grid/types';

export const makeActionsMasterIssueRowsModel = (
  actions: ActionDto[],
  issueCode: string,
  // NOTE: due date are diff. type is wrong.
): MasterIssueRowModel[] =>
  actions.map((action) => ({
    id: action.id,
    // NOTE: Each value will be displayed in the grid column by parent-child relationship
    path: [issueCode, action.title],
    // TODO ActionDto has a wrong type for status
    status: action.status as MasterIssueRowModel['status'],
    createdAt: action.createdAt,
    dueDate: action.dueDate,
    updatedAt: action.updatedAt,
    owner: action.owner,
    approver: action.approver,
    code: action.id,
    title: action.title,
  }));

export const mapIssueGetToMasterIssueRowModel = (
  issues: GetIssueResponseDto[],
): MasterIssueRowModel[] =>
  issues.map((issue) => {
    const {
      slaEnabled: _slaEnabled,
      slaStateReason: _slaStateReason,
      slaStateChangedBy: _slaStateChangedBy,
      slaStateChangedByName: _slaStateChangedByName,
      slaStateChangedAt: _slaStateChangedAt,
      escalationDays: _escalationDays,
      maxDueDate: _maxDueDate,
      reminderDays: _reminderDays,
      slaDays: _slaDays,
      slaStatus: _slaStatus,
      actions: _actions,
      govmapGroups: _govmapGroups,
      ...row
    } = issue;
    return {
      ...row,
      path: [issue.code],
      status: issue.status as MasterIssueRowModel['status'],
      // NOTE: due date are diff. type is wrong.
      dueDate: issue.dueDate as unknown as MasterIssueRowModel['dueDate'],
      severity: issue.severity as MasterIssueRowModel['severity'],
      actions: issue.actions as MasterIssueRowModel['actions'],
    };
  });
